import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Breadcrumb } from '@rivethealth/data/breadcrumb';

@Component({
  selector: 'page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent {
  @Input()
  title: string = '';

  @Input()
  titlePhi: boolean = false;

  @Input()
  customBreadcrumb?: Breadcrumb[];

  @Input()
  href: string;

  @Input()
  target: string;

  @Output()
  readonly breadcrumbClick = new EventEmitter<number>();

  constructor() {}
}
